import classNames from 'classnames';
import moment from 'moment';
import React, {CSSProperties, FunctionComponent} from 'react';
import DatePicker from 'react-datepicker';
import {NotificationEditorContentProps} from '../..';
import {InputLabelEditor} from '../../../InputLabelEditor';

const Styles: Record<string, CSSProperties> = {
  inputContainer: {
    marginBottom: 16,
  },
  toggleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 16,
  },
  toggleLabelContainer: {
    marginLeft: 8,
  },
  toggleUnderLabel: {
    fontSize: 12,
    color: '#959DAF',
  },
  selectedToggleLabel: {
    fontWeight: 'bold',
    color: '#4054CC',
  },
};

export const NotificationEditorMetaData: FunctionComponent<NotificationEditorContentProps> = ({
  data,
  onChange,
  selectedDateToggle,
  isCreation,
  setSelectedDateToggle,
}) => {
  const immediateDate =
    data.scheduledDate && moment(data.scheduledDate).isSameOrBefore(moment());

  return (
    <div>
      <div style={Styles.inputContainer}>
        <InputLabelEditor title="NAME" isRequired />
        <input
          className="form-control"
          value={data?.name}
          onChange={e => onChange('name', e.target.value)}
        />
      </div>
      <div style={Styles.inputContainer}>
        <InputLabelEditor title="DATE / HEURE" isRequired={!isCreation} />
        <div style={Styles.toggleContainer}>
          <div>
            <i
              style={{color: immediateDate ? '#4054CC' : 'black'}}
              onClick={() => {
                if (immediateDate) {
                  onChange('scheduledDate', undefined);
                } else {
                  setSelectedDateToggle(false);
                  onChange('scheduledDate', moment().utc().format());
                }
              }}
              className={classNames('fa fa-2x', {
                'fa-toggle-on': immediateDate,
                'fa-toggle-off': !immediateDate,
              })}
            />
          </div>
          <div style={Styles.toggleLabelContainer}>
            <div style={immediateDate ? Styles.selectedToggleLabel : undefined}>
              envoi immédiat
            </div>
            <div style={Styles.toggleUnderLabel}>
              Une fois valider l’envoi est immédiat
            </div>
          </div>
        </div>
        <div style={Styles.toggleContainer}>
          <div>
            <i
              style={{color: selectedDateToggle ? '#4054CC' : 'black'}}
              onClick={() => {
                if (selectedDateToggle) {
                  setSelectedDateToggle(false);
                  onChange('scheduledDate', undefined);
                } else {
                  onChange('scheduledDate', undefined);
                  setSelectedDateToggle(true);
                }
              }}
              className={classNames('fa fa-2x', {
                'fa-toggle-on': selectedDateToggle,
                'fa-toggle-off': !selectedDateToggle,
              })}
            />
          </div>
          <div style={Styles.toggleLabelContainer}>
            <div
              style={
                selectedDateToggle ? Styles.selectedToggleLabel : undefined
              }>
              envoi différé
            </div>
            <div style={Styles.toggleUnderLabel}>Choisir une date</div>
          </div>
        </div>
        {selectedDateToggle && (
          <div id="NotificationEditor" style={{marginLeft: 35}}>
            <DatePicker
              selected={
                data.scheduledDate ? new Date(data.scheduledDate) : null
              }
              onChange={date => {
                if (moment(date).isSameOrBefore(moment())) {
                  setSelectedDateToggle(false);
                }
                onChange('scheduledDate', moment(date).utc().format());
              }}
              showTimeSelect
              timeFormat="HH:mm"
              timeIntervals={15}
              dateFormat="d/M/yyyy hh:mm aa"
              timeCaption="time"
              placeholderText="Select Date"
            />
          </div>
        )}
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/NotificationEditor/components/NotificationEditorMetaData/index.tsx